import { api_gateway } from '../../conexoes/api'
import decryptJWT from '../../utils/decryptJWT'
import { requestResolver } from '../../utils/requestResolver'

export const DispositivosService = {
  //#region GET
  getOperadoras: () => {
    const codigoCliente = decryptJWT('codigoCliente')

    return requestResolver(
      api_gateway.get(
        `/m1/consultar/operadora/operadora_cliente_simcard?cd_pav_cliente=${codigoCliente}`
      )
    )
  },
  getSimcardTipo: () => {
    return requestResolver(api_gateway.get('/m1/consultar/simcard_tipo'))
  },
  getGruposPadroes: () => {
    return requestResolver(
      api_gateway.get('/m1/consultar/simcard_grupo?fl_padrao=1')
    )
  },
  getGruposCliente: () => {
    const codigoCliente = decryptJWT('codigoCliente')
    
    return requestResolver(
      api_gateway.get(
        `/m1/consultar/simcard_grupo?fl_padrao=0&cd_pav_cliente=${codigoCliente}`
      )
    )
  },
  getRede: () => {
    return requestResolver(api_gateway.get(`/api/v2/devices/carriers`))
  },
  getConsultarDadosSelect: (rota) => {
    return requestResolver(
      api_gateway.post('/m1/consultar/select', {
        dados: {},
        condicao: {
          paramRota: rota
        }
      })
    )
  },
  getStatusContrato: () => {
    const codigoCliente = decryptJWT('codigoCliente')

    return requestResolver(
      api_gateway.get(
        `/m1/consultar/simcard_opcoes_filtros?codigo_cliente=${codigoCliente}`
      )
    )
  },
  getPlans: (cdOperadoras, codigoUsuario) => {
    const cdOperadorasString = cdOperadoras.join(',')
    return requestResolver(
      api_gateway.get(
        `/m1/consultar/fat_plano?cd_pav_usuario=${codigoUsuario}&cd_operadora=${cdOperadorasString}`
      )
    )
  }

  //#endregion GET
}
